export const VIRTUAL_RINGS = 2;

export const isVirtualRingId = (ringId: string): boolean =>
  ringId.startsWith('virtualRing');
